module.exports = __webpack_public_path__ + "static/media/arizona.8682fe71.jpg";